import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const centroCostoImporterSelectors = importerSelectors(
  'centroCosto.importer',
);

export default centroCostoImporterSelectors;
